import React from 'react';
import PropTypes from 'prop-types';

import Content from './Content';
import { SensitiveInfoInputProvider } from './Context';

const SensitiveInfoInput = ({
  className,
  resource,
  attrName,
  error,
  label,
  hidden,
  value,
  onChange,
  onSubmit,
  helperText,
  fullWidth,
  mask,
  writeOnly,
  relationshipName,
  LockedInputComponent,
  UnlockedInputComponent,
}) => {
  return (
    <SensitiveInfoInputProvider
      resource={resource}
      relationshipName={relationshipName}
      onSubmit={onSubmit}
      writeOnly={writeOnly}
    >
      <Content
        className={className}
        resource={resource}
        relationshipName={relationshipName}
        attrName={attrName}
        LockedInputComponent={LockedInputComponent}
        LockedInputProps={{
          value,
          fullWidth,
          label,
          hidden,
          mask,
        }}
        UnlockedInputComponent={UnlockedInputComponent}
        UnlockedInputProps={{
          error,
          value,
          onChange,
          helperText,
          fullWidth,
          label,
          hidden,
        }}
      />
    </SensitiveInfoInputProvider>
  );
};

SensitiveInfoInput.defaultProps = {
  className: '',
  fullWidth: false,
  label: '',
  hidden: false,
  error: null,
  onSubmit: null,
  mask: '',
  writeOnly: null,
  LockedInputComponent: undefined,
  UnlockedInputComponent: undefined,
};

SensitiveInfoInput.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.object.isRequired,
  relationshipName: PropTypes.string.isRequired,
  attrName: PropTypes.string.isRequired,
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  hidden: PropTypes.bool,
  writeOnly: PropTypes.bool,
  mask: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  helperText: PropTypes.string.isRequired,
  LockedInputComponent: PropTypes.object,
  UnlockedInputComponent: PropTypes.object,
};

export default SensitiveInfoInput;
